import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdCall } from 'react-icons/md';

const Phone: React.FC<IconBaseProps> = (props) => <MdCall {...props} />;

export default Phone;
